import thunderUrl from '../assets/audio/sfx/weather/thunder.mp3';
import { mixer } from './audio-mixer.js';

/** Decoded up front: thunder arrives seconds after its flash, so a late decode would land it on the wrong strike. */
void mixer.engine.decode(thunderUrl);

/**
 * Thunder for a storm strike (`WeatherLayer.onThunder`), once its sound reaches the camera: `strength` 0–1 sets the loudness and
 * `distance` (0 overhead, 1 on the horizon) quietens it and slows it a little, so a far roll is lower and duller than a crack overhead.
 */
export function playThunder(strength: number, distance: number) {
  mixer.playSfx(thunderUrl, 1.04 * strength * (1 - .55 * distance), undefined, 1 - .18 * distance);
}
